import { useTranslation as useTranslationI18 } from 'react-i18next';

import { TranslationKeys } from 'data/translations/de/de';

export type TranslationFunction = (
    key: TranslationKeys,
    options?: string | object
) => string;
export function useTranslation() {
    const { t: t18Next, ...rest } = useTranslationI18();

    const t: TranslationFunction = (
        key: TranslationKeys,
        options?: string | object
    ) => {
        return t18Next(key, options);
    };

    return { ...rest, t };
}
